import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import spanGroup from "../../assets/icons/span-group.gif";
import spanGroup2 from "../../assets/icons/span-group-2.gif";
import backArrowSpan from "../../assets/icons/back-arrow-span.svg";
import verticalArrows from "../../assets/icons/vertical-arrows-span.svg";
import heroMainImage from "../../assets/images/hero-main-img.png";
import heroBG from "../../assets/images/hero-bg.png";
import exesGroup from "../../assets/icons/white-exes-animated.gif";
import { styled } from "@mui/material";
import { keyframes } from "@mui/material";
import AppButton from "../app-button";
import PlatformBox from "../platform-box";

const sxStyles = {
  mainContainer: {
    minHeight: "681px",
    alignItems: "center",
    backgroundImage: `url(${heroBG})`,
    backgroundSize: "cover",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    position: "relative",
    paddingTop: { xs: "25px", md: "100px" },
    paddingBottom: { xs: "20px", md: "85px" },
    minWidth: "375px",
    xs: { flexDirection: "column", overflow: "none" },
  },
  content: {
    display: "flex",
    justifyContent: { xs: "center", md: "space-between" },
    alignItems: { xs: "center", md: "space-between" },
    paddingLeft: { xs: "0px", md: "80px" },
    paddingRight: { xs: "0px", md: "80px" },
    boxSizing: "border-box",
    flexDirection: { xs: "column-reverse", md: "row" },
    minWidth: { xs: "375px" },
    width: "100%",
    maxWidth: "1440px",
  },
  mainTitle: {
    color: "#FDD925",
    fontWeight: "700",
    fontSize: { xs: "55px", lg: "96px" },
    lineHeight: { xs: "55px", lg: "96px" },
    fontFamily: "p22-arts-and-crafts",
    textAlign: "left",
  },
  subtext: {
    fontFamily: "IBM Plex Sans",
    color: "white",
    fontSize: { xs: "16px", md: "24px" },
    textAlign: "left",
    lineHeight: { xs: "20px", md: "34px" },
    paddingLeft: { xs: "20px", md: 0 },
    paddingRight: { xs: "20px", md: 0 },
  },
  rightBgArrows: {
    position: "absolute",
    right: "20px",
    top: "20px",
  },
};

const float = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0);
  }
`;

const FloatImage = styled("img")({
  animation: `${float} 2s ease-in-out infinite`,
  width: "100%",
  height: "auto",
});

const Hero = () => {
  return (
    <Grid container sx={sxStyles.mainContainer}>
      <Grid sx={sxStyles.content}>
        <Box
          sx={{
            position: "absolute",
            top: "-15px",
            left: "50px",
            display: { xs: "none", md: "block" },
            height: "44px",
            width: "220px",
          }}
        >
          <img
            src={exesGroup}
            alt={""}
            style={{ height: "44px", width: "220px" }}
          />
        </Box>
        <Grid
          sx={{ display: "flex", flexDirection: { xs: "column", md: "row" } }}
        >
          <Stack>
            <Grid
              sx={{
                flexDirection: "row",
                marginTop: { xs: "20px", md: "80px" },
              }}
            >
              <Stack>
                <Grid
                  sx={{
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#FDD925",
                      fontFamily: "IBM Plex Sans",
                      fontSize: { xs: "24px", md: "32px" },
                      marginRight: "20px",
                      letterSpacing: "-1px",
                      paddingLeft: { xs: "25px", md: 0 },
                    }}
                  >
                    BIENVENIDXS A
                  </Typography>
                  <Grid
                    sx={{
                      display: { xs: "flex", md: "" },
                      flexDirection: { xs: "row", md: "" },
                    }}
                  >
                    <Box
                      sx={{
                        height: { xs: "22px", md: "auto" },
                        width: { xs: "19px", md: "auto" },
                        marginRight: "17px",
                      }}
                    >
                      <img src={backArrowSpan} alt={""} />
                    </Box>
                    <Box
                      sx={{
                        height: { xs: "22px", md: "auto" },
                        width: { xs: "19px", md: "auto" },
                      }}
                    >
                      <img src={backArrowSpan} alt={""} />
                    </Box>
                  </Grid>
                </Grid>
                <Box
                  sx={{
                    zIndex: 1,
                    position: "absolute",
                    left: { xs: "205px", md: "800px" },
                    top: { xs: "450px", md: "350px" },
                    height: { xs: "165px", md: "155px" },
                    width: { xs: "160px", md: "145px" },
                  }}
                >
                  <img
                    src={spanGroup}
                    alt={""}
                    style={{ width: "100%", height: "100%" }}
                  />
                </Box>
              </Stack>
            </Grid>
            <Stack
              sx={{
                alignSelf: { xs: "flex-start", md: "" },
                paddingLeft: { xs: "25px", md: 0 },
              }}
            >
              <Typography sx={sxStyles.mainTitle}>BIZARRAP</Typography>
              <Grid
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <Typography
                  fontFamily={"p22-arts-and-crafts"}
                  sx={sxStyles.mainTitle}
                >
                  SOCIAL
                </Typography>
                <Typography
                  fontFamily={"p22-arts-and-crafts"}
                  sx={sxStyles.mainTitle}
                >
                  CLUB
                </Typography>
              </Grid>
            </Stack>
            <Stack sx={{ marginTop: "15px" }}>
              <Typography sx={sxStyles.subtext}>
                Una comunidad de cards coleccionables del mundo
              </Typography>
              <Typography sx={sxStyles.subtext}>
                Bzrp con premios y beneficios exclusivos.
              </Typography>
            </Stack>
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              <PlatformBox />
              {/*<AppButton bgColor={"#FED301"} color={"black"} />*/}
            </Box>
          </Stack>
          <Box
            sx={{
              position: "absolute",
              left: "20px",
              top: "350px",
              width: "50px",
              height: "320px",
              display: { xs: "none", md: "" },
            }}
          >
            <img src={spanGroup2} alt={""} />
          </Box>
        </Grid>
        <Grid
          sx={{ display: "flex", flexDirection: { xs: "column", md: "row" } }}
        >
          <Box
            sx={{
              height: { xs: "360px", lg: "585px" },
              width: { xs: "330px", lg: "534px" },
            }}
          >
            <FloatImage src={heroMainImage} />
          </Box>
          <Box
            sx={{
              position: "absolute",
              right: "65px",
              top: "167px",
              display: { xs: "none", md: "flex" },
            }}
          >
            <img src={verticalArrows} alt={""} />
          </Box>
        </Grid>
        <img
          src={exesGroup}
          style={{ position: "absolute", top: "790px", left: "1480px" }}
          alt={""}
        />
      </Grid>
    </Grid>
  );
};

export default Hero;
